module.exports = __webpack_public_path__ + "img/Business Mathematics.6f3f39e1.svg";